import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/menus/$menuId/categories"
)({
  component: CategoriesLayout,
});

function CategoriesLayout() {
  return <Outlet />;
}
